import * as React from "react"
import * as ReactDOM from "react-dom"
import AppRedux from "./AppRedux"

const rootElement=document.getElementById("root")
ReactDOM.render(<AppRedux/>,rootElement)